import { IpoAuthoringDataType } from "../IpoBase/IpoBaseAuthoringType";
import IpoBaseServerWrapper from "../IpoBase/IpoBaseServerWrapper";
import CurrentIPOClient from "./CurrentIPOClient";

const CurrentIPOServer = async (authoringData: IpoAuthoringDataType = {}) => {
  return (
    <IpoBaseServerWrapper
      authoringData={authoringData}
      defaultIpoType="current"
      renderClient={(mainboardInitial, smeInitial) => (
        <CurrentIPOClient
          mainboardInitial={mainboardInitial}
          smeInitial={smeInitial}
          authoringData={authoringData}
        />
      )}
    />
  );
};

export default CurrentIPOServer;
